import React from 'react';
import * as M from '@mui/material';
import * as S from './styles';
import { lightTheme } from '../../themes';
import { mainTheme } from './styles';
import { createTheme } from '@mui/material/styles';

const mapToTheme = {
  light: lightTheme,
  main: mainTheme,
};

const customTheme = createTheme({
  spacing: 1,
});

export default function AxlInput({ children, spacing = 1, theme = 'light', ...props }) {
  return (
    <M.ThemeProvider theme={mapToTheme[theme]}>
      <M.Box mb={1} width={1} padding={customTheme.spacing(spacing)} boxSizing={'border-box'}>
        <M.InputBase fullWidth {...props}>
          {children}
        </M.InputBase>
        {props.errors &&
          props.errors.map((e, i) => (
            <S.TextError key={`error-${i}`} style={{ color: 'red' }}>
              &bull; {e}
            </S.TextError>
          ))}
      </M.Box>
    </M.ThemeProvider>
  );
}
